<template>
  <ChartLine
    ref="chart"
    :data="data"
    :intervalTime="intervalTime"
    :type="'areaChart'"
  />
</template>

<script>
import chartLine from './chart-line.vue';
export default {
  name: 'ChartArea',
  components: {
    chartLine
  },
  props: {
    data: {},
    intervalTime: {}
  }
};
</script>
